module.exports = __webpack_public_path__ + "static/media/Assets-05-MNM-02.51870d47.png";